(self.webpackChunkyourkaya = self.webpackChunkyourkaya || []).push([
    [6460],
    {
        2113: () => {
            document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((e) => {
                e.addEventListener("click", (t) => {
                    t.preventDefault();
                    const r = e.getAttribute("href");
                    document.querySelector(r).scrollIntoView({ behavior: "smooth", block: "start" });
                });
            });
        },
    },
    (e) => {
        var t;
        (t = 2113), e((e.s = t));
    },
]);
